'use client';

import { getBackground } from '@/theme/backgrounds';
import React from 'react';
import { HLVS3DComponentProps } from '../section/interfaces';
import Heading from '../common/Heading';
import { TextWithDropShadow } from '../TextWithDropShadow';

const HlvsImageDescription: React.FC<HLVS3DComponentProps> = ({
  title,
  background,
  layout,
  data = [],
}) => {
  const getFlexDirection = (index: number) => {
    switch (layout?.position) {
      case 'Right':
        return 'md:flex-row-reverse';
      case 'Left':
        return 'md:flex-row';
      case 'RLR':
        return index % 2 === 0 ? 'md:flex-row-reverse' : 'md:flex-row';
      case 'LRL':
        return index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse';
      default:
        return 'md:flex-row';
    }
  };

  return (
    <div
      className='w-full md:px-8'
      style={
        background?.url
          ? {
              backgroundImage: `url(${background.url})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
            }
          : {
              background: background?.style && getBackground(background.style),
            }
      }
    >
      {/* Section Title */}
      {title && (
        <div className='max-w-96: flex justify-center px-4 pt-10'>
          <div className='w-full text-center leading-7 md:w-[600px]'>
            <Heading size={title.size.size.split('')[1] || '3'}>
              <TextWithDropShadow
                text={title.text || ''}
                color={{
                  shadow: 'text-white',
                  text: title.color?.color || 'white',
                }}
                displayShadow={title.shadow}
              />
            </Heading>
          </div>
        </div>
      )}

      {data.map((content, index) => (
        <div
          key={index}
          className={`flex flex-col flex-col-reverse ${getFlexDirection(index)} mx-auto max-w-6xl items-center justify-center gap-8 px-4 py-10 md:gap-12 md:py-16`}
        >
          <div
            className={`flex w-[401px] w-full justify-center md:w-[306px] lg:w-[704px]`}
          >
            {content?.mainImage?.url && (
              <img
                src={content.mainImage.url}
                alt={content.mainImage.altText}
                className='h-full w-full rounded-xl object-cover'
              />
            )}
          </div>

          <div className='justify-left flex w-[401px] flex-col items-center text-left md:w-[306px] md:justify-center md:text-left lg:w-[704px]'>
            <div className='w-full max-w-80 px-2 sm:max-w-96 sm:px-0 md:max-w-80'>
              {content?.title && !content.title.hidden && (
                <Heading size={content.title.size.size.split('')[1]}>
                  <TextWithDropShadow
                    text={content.title.text}
                    color={{
                      shadow: 'text-white',
                      text: content.title.color?.color || 'white',
                    }}
                    displayShadow={content.title.shadow}
                  />
                </Heading>
              )}
            </div>

            {content?.bodyText && !content.bodyText.hidden && (
              <div className='w-full max-w-80 px-2 text-base font-semibold sm:max-w-96 sm:px-0 md:max-w-80 '>
                {/* <Heading size={content.bodyText.size.size.split('')[1]}> */}
                <TextWithDropShadow
                  text={content.bodyText.text}
                  color={{
                    shadow: 'text-white',
                    text: content.bodyText.color?.color || 'white',
                  }}
                  displayShadow={content.bodyText.shadow}
                />
                {/* </Heading> */}
              </div>
            )}

            {content.embededImage && (
              <div className='w-full max-w-96 md:max-w-80'>
                <img
                  src={content.embededImage.url}
                  alt={content.embededImage.altText || ''}
                  className='mt-4 w-[40px]'
                />
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default HlvsImageDescription;
